import { render, staticRenderFns } from "./PowerWriterMain.vue?vue&type=template&id=1c99854d&scoped=true"
import script from "./PowerWriterMain.vue?vue&type=script&lang=js"
export * from "./PowerWriterMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c99854d",
  null
  
)

export default component.exports